<div class="row header">
  <div class="steps-header col-12 px-3 px-lg-4">
    <ul>
      @for (step of steps; track step; let i = $index) {
        @if (!step.hide) {
          <li [routerLink]="step.path" class="step-col" [ngClass]="{ 'step-primary': i >= activeIndex }">
            <div class="header-label">{{ step.label | translate }}</div>
            <div class="step-point"></div>
          </li>
        }
      }
    </ul>
    <div class="d-flex flex-row">
      <app-help-content [key]="key + steps[signDocumentRequest.currentStep].path" class="mx-2"></app-help-content>
      <app-language-switch class="ml-2"></app-language-switch>
    </div>
  </div>
</div>
